import { useState } from "react";
import { Link } from "react-router-dom";
import { appPaths } from "../../Routes";
import Button from "../Button";
import ByRegionEvidence from "./ByRegionEvidence";
import GlobalEvidence from "./GlobalEvidence";
import SectionTitle from "../SectionTitle";
import { EvidenceForRegion } from "../../api/models/Dashboard";

export type EvidenceSectionProps = {
    evidenceMissingCount: number;
    evidenceExpiringInNext30DaysCount: number;
    evidenceInDateCount: number;
    dataSourceEvidenceByRegion: EvidenceForRegion[];
};

const EvidenceSection = ({
    evidenceMissingCount,
    evidenceExpiringInNext30DaysCount,
    evidenceInDateCount,
    dataSourceEvidenceByRegion,
}: EvidenceSectionProps) => {
    const [view, setView] = useState<"by-region" | "global">("by-region");

    return (
        <>
            <SectionTitle title="Evidence">
                <div className="flex flex-wrap sm:ml-auto gap-3 sm:space-y-0 mt-4">
                    <Button
                        className="whitespace-nowrap"
                        variant={view === "by-region" ? "primary" : "outline"}
                        onClick={() => setView("by-region")}
                    >
                        Emissions sources
                    </Button>
                    <Button
                        className="whitespace-nowrap"
                        variant={view === "global" ? "primary" : "outline"}
                        onClick={() => setView("global")}
                    >
                        Global
                    </Button>
                    <Link
                        className="block"
                        to={`${appPaths.evidence}?statusFilter=ExpiringWithin30Days`}
                    >
                        <Button variant="outline">View breakdown</Button>
                    </Link>
                </div>
            </SectionTitle>
            {view === "by-region" ? (
                <ByRegionEvidence
                    emissionsSourceEvidenceByRegion={dataSourceEvidenceByRegion}
                />
            ) : (
                <div className="py-6">
                    <GlobalEvidence
                        evidenceMissingCount={evidenceMissingCount}
                        evidenceExpiringInNext30DaysCount={
                            evidenceExpiringInNext30DaysCount
                        }
                        evidenceInDateCount={evidenceInDateCount}
                    />
                </div>
            )}
        </>
    );
};

export default EvidenceSection;
